import {getNaverPayPointByApi} from '@web/pageHelpers/ordersheet'
import {getPoints, getRewardStatus} from '@web/slices/rewardPoint/slice'
import makeSlice from '@web/slices/rewardPoint/sliceMaker'

import {initOrderSheetByAPI} from '../../actions/familyPay'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {data} = payload

            const {rewardPoint} = data.naverpayPoint ?? getNaverPayPointByApi()

            state.amount = rewardPoint.rewardPointBalance ?? 0
            state.cashPoint = rewardPoint.cashableRewardPointBalance ?? 0
            state.status = getRewardStatus(rewardPoint.success)
            state.descriptions = getPoints({
                totalBalance: rewardPoint.rewardPointBalance ?? 0,
                points: rewardPoint.rewardPointDescriptions ?? [],
            })
        })
    },
})

export default slice.reducer
